
import { defineComponent } from 'vue';
import { popModal } from 'jenesius-vue-modal';

export default defineComponent({
  props: {
    hasCloseButton: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['onClose'],

  setup(props, ctx) {
    const closeThis = () => {
      ctx.emit('onClose');
      popModal();
    };

    return { closeThis, props };
  },
});
